const updateQuestions = {
  toastrTrue: 'Grupo actualizado',
  toastrFalse: 'Pregunta actualizada',
  txt: ' fue actualizado con éxito'
};

export default updateQuestions;
